import { FC } from 'react'
import {
  Card,
  CardBody,
  CardHeader,
  CardSubtitle,
  CardTitle,
  GridLayout,
  GridLayoutItem
} from '@progress/kendo-react-layout'
import { Typography } from '@progress/kendo-react-common'
import { Input, TextArea } from '@progress/kendo-react-inputs'
import { MultiLineBody } from './MultiLineBody'
import { useAppSelector } from '../../stores'

interface SupplierHearingHeaderProps {
  regStatus?: string
  promptInfo?: string
  supplierHeaderInfo?: {
    replyYm: string
    supplierNm: string
    expense: string
    branchNm: string
    factoryNm: string
    supplierBranchNm: string
  }
}

export const SupplierHearingHeader: FC<SupplierHearingHeaderProps> = (
  props
) => {
  const { headerInfo } = useAppSelector((state) => state.confirmreply)

  return (
    <Card orientation="horizontal">
      <CardHeader>
        <CardTitle>
          <span
            style={{ fontSize: '1.2em', fontWeight: 'bold', color: 'gray' }}
          >
            {props.supplierHeaderInfo?.replyYm}
          </span>
        </CardTitle>
        <CardSubtitle>
          <span
            style={{ fontSize: '1.2em', fontWeight: 'bold', color: 'gray' }}
          >
            {props.regStatus === '1'
              ? '未登録'
              : props.regStatus === '2'
                ? '一時保存'
                : props.regStatus === '3'
                  ? '登録済'
                  : props.regStatus === '4'
                    ? '未登録（事前調整）'
                    : ''}
          </span>
        </CardSubtitle>
      </CardHeader>
      <CardBody>
        <GridLayout gap={{ rows: 5, cols: 0 }}>
          <GridLayoutItem col={1} row={1}>
            <span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>
              {props.supplierHeaderInfo?.branchNm}
            </span>
          </GridLayoutItem>
          <GridLayoutItem col={1} row={2}>
            <span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>
              {props.supplierHeaderInfo?.expense}
            </span>
          </GridLayoutItem>
          <GridLayoutItem col={1} row={3}>
            <span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>
              {props.supplierHeaderInfo?.supplierNm}
              {' '}{props.supplierHeaderInfo?.supplierBranchNm}
              {props.supplierHeaderInfo?.factoryNm !== undefined
                ? `${props.supplierHeaderInfo.factoryNm}`
                : ''}
            </span>
          </GridLayoutItem>

          <GridLayoutItem col={2} row={1} rowSpan={4}>
            <TextArea
              rows={4}
              placeholder={'回答コメントを入力して下さい。'}
              style={{ width: '20vw' }}
              readOnly={true}
              value={headerInfo?.replyComment ?? undefined}
            />
          </GridLayoutItem>
          <GridLayoutItem col={2} row={5}>
            <Input
              style={{ width: '10vw' }}
              placeholder={'回答者(姓)'}
              disabled={true}
              value={headerInfo?.replyNmLast ?? undefined}
            />
            <Input
              style={{ width: '10vw' }}
              placeholder={'回答者(名)'}
              disabled={true}
              value={headerInfo?.replyNmFirst ?? undefined}
            />
          </GridLayoutItem>

          <GridLayoutItem col={3} row={1} rowSpan={4}>
            <TextArea
              rows={4}
              placeholder={'修正内容を入力して下さい。'}
              style={{ width: '20vw' }}
              readOnly={true}
              value={headerInfo?.fixContent ?? undefined}
            />
          </GridLayoutItem>

          <GridLayoutItem col={4} rowSpan={3}>
            <Typography.p
              fontWeight={'bold'}
              themeColor={'error'}
              fontSize={'large'}
            >
              <MultiLineBody body={props.promptInfo} />
            </Typography.p>
          </GridLayoutItem>
        </GridLayout>
      </CardBody>
    </Card>
  )
}
